<ng-container *ngIf="worksheets$ | withLoading | async as worksheets">
  <ng-container *ngIf="worksheets.data">
    <div class="bg-primary text-white">
      <div class="container worksheet-container pt-lg-2 pb-4">
        <!-- Left side - Main Player -->
        <ng-container *ngIf="currentItem">
          <div *ngIf="currentItem.WorksheetType === 2" class="player-section">
            <div class="worksheet-wrapper" [ngClass]="{ 'single-worksheetitem': isWorksheetItems }">
              <fgb-worksheet-item [worksheetItem]="currentItem" [worksheetId]="worksheetId"></fgb-worksheet-item>
              <div class="worksheet-details">
                <h3>{{ currentItem.Title }}</h3>
                <p class="font-size-14">{{ currentItem.Description }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Right side - Playlist -->
        <ng-container *ngFor="let worksheetGroup of worksheets.data">
          <ng-container *ngIf="hasWorksheetType(worksheetGroup.Items, 2)">
            <div class="playlist-section mt-3 pe-2">
              <div [class.row]="isList" class="flex-lg-wrap flex-nowrap">
                <ng-container *ngFor="let item of worksheetGroup.Items">
                  <ng-container *ngIf="item.WorksheetType === 2">
                    <div
                      class="worksheet-item mb-3"
                      [class.active]="item.Id === currentItem.Id"
                      (click)="selectWorksheetItem(item)"
                    >
                      <div class="thumbnail-container">
                        <div class="thumbnail position-relative">
                          <img [src]="item.Image | contentImage : '7'" [alt]="item.Title" />
                          <div class="playing-overlay">
                            <span class="">{{ 'worksheet.now.playing.text' | translate }}</span>
                          </div>
                          <div class="overlay">
                            <span class="icon material-icons play-button">play_circle</span>
                          </div>
                        </div>
                        <div class="worksheet-info mt-2">
                          <h6 class="font-size-14 font-bold">{{ item.Title }}</h6>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="container">
      <div *ngFor="let worksheetGroup of worksheets.data">
        <h2 class="card-header font-page-heading border-0 pb-0">
          {{ 'worksheet.gallery.images' | translate }}
        </h2>
        <div [class.row]="isList">
          <ng-container *ngFor="let item of worksheetGroup.Items">
            <ng-container *ngIf="item.WorksheetType == 1">
              <div [class.col-lg-4]="isList" class="col-6">
                <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item></div
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- No Data available -->
  <ng-container *ngIf="worksheets.isEmpty"> <p>No worksheet available</p></ng-container>

  <!-- Error -->
  <ng-container *ngIf="worksheets.error">
    <p>Error {{ worksheets.error }}</p>
  </ng-container>

  <!-- Loading -->
  <ng-container *ngIf="worksheets.isLoading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
</ng-container>
